'use client';

import Link from 'next/link';

import { logoutAction } from '@/features/auth/server/actions';
import { useI18n } from '@/features/i18n/components/client/I18nContext';
import { LanguageSwitcher } from '@/features/i18n/components/client/LanguageSwitcher';
import { useReportError } from '@/hooks/useReportError';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  const { t, locale } = useI18n();
  useReportError(error);

  return (
    <main className="min-h-dvh grid place-items-center p-6">
      <div className="max-w-lg w-full text-center space-y-4">
        <h1 className="text-2xl font-semibold">{t('error.title')}</h1>
        <p className="text-neutral-600">{t('error.description')}</p>
        <div className="flex items-center justify-center gap-3">
          <Link className="px-4 py-2 rounded-md border border-neutral-300" href={`/${locale}`}>
            {t('error.goHome')}
          </Link>
          <button
            className="px-4 py-2 rounded-md bg-white text-error-500 border border-error-500 cursor-pointer"
            type="button"
            onClick={() => {
              void logoutAction(locale);
            }}
          >
            {t('error.logout')}
          </button>
          <LanguageSwitcher />
        </div>
      </div>
    </main>
  );
}
